// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
:host {
  display: inline-block;
  width: 100%;
  height: auto;
}
:host .container {
  height: 100%;
}

.loader {
  margin-top: -170px;
}

.loading-wrapper {
  min-height: 300px;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.wineglass {
  height: 108px;
  position: relative;
}

.wineglass:after {
  content: "";
  position: absolute;
  top: 141px;
  left: 15px;
  width: 60px;
  height: 15px;
  background: white;
  box-shadow: 0 0 1px white;
}

.top {
  background: white;
  width: 90px;
  height: 108px;
  border-radius: 0 0 36px 36px;
  box-shadow: 0 0 1px white;
}

.top:before {
  content: "";
  position: absolute;
  left: 12px;
  bottom: 12px;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background: linear-gradient(transparent 50%, #5c0a31 50%);
}

.left .top:before {
  animation: rotate2 2s linear infinite;
}

.right .top:before {
  animation: rotate1 2s linear infinite;
}

.top:after {
  content: "";
  position: absolute;
  top: 105px;
  left: 36px;
  width: 18px;
  height: 39px;
  background: white;
  box-shadow: 0 0 1px white;
}

.left {
  display: inline-block;
  margin-right: 30px;
  animation: rotate1 2s cubic-bezier(0.39, 1.52, 0.46, 0.92) infinite;
}

.right {
  display: inline-block;
  animation: rotate2 2s cubic-bezier(0.39, 1.52, 0.46, 0.92) infinite;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 210px;
  height: 75px;
  position: relative;
  opacity: 0;
  animation: 2s fadeInUp infinite linear 2s;
}

li {
  width: 6px;
  height: 15px;
  background: white;
  position: absolute;
  box-shadow: 0 0 1px white;
  transform-origin: bottom;
}

li:nth-child(1) {
  left: 78px;
  bottom: 15px;
  transform: rotate(-35deg);
}

li:nth-child(2) {
  left: 102px;
  bottom: 24px;
}

li:nth-child(3) {
  left: 126px;
  bottom: 15px;
  transform: rotate(35deg);
}

.small {
  transform: scale(0.35);
}
.small.loading-wrapper {
  min-height: auto;
}
.small .loader {
  margin-top: -100px;
}

.grey .wineglass:after {
  background: #efefef;
  box-shadow: 0 0 1px #efefef;
}
.grey .top {
  background: #efefef;
  box-shadow: 0 0 1px #efefef;
}
.grey .top:after {
  background: #efefef;
  box-shadow: 0 0 1px #efefef;
}
.grey li {
  background: #efefef;
  box-shadow: 0 0 1px #efefef;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/layout/components/general/loading-icon/loading-icon.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AAAF;AAEE;EACE,YAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AADF;;AAMA;EACE,aAAA;EACA,kBAAA;AAHF;;AAMA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,4BAAA;EACA,yBAAA;AAHF;;AAMA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;AAHF;;AAMA;EACE,qCAAA;AAHF;;AAMA;EACE,qCAAA;AAHF;;AAMA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,kBAAA;EACA,mEAAA;AAHF;;AAMA;EACE,qBAAA;EACA,mEAAA;AAHF;;AAMA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,yCAAA;AAHF;;AAMA;EACE,UAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;AAHF;;AAMA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;AAKE;EACE,gBAAA;AAHJ;AAME;EACE,kBAAA;AAJJ;;AASE;EACE,mBDpIS;ECqIT,2BAAA;AANJ;AASE;EACE,mBDzIS;EC0IT,2BAAA;AAPJ;AAUE;EACE,mBD9IS;EC+IT,2BAAA;AARJ;AAWE;EACE,mBDnJS;ECoJT,2BAAA;AATJ","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n\n:host {\n  display: inline-block;\n  width: 100%;\n  height: auto;\n\n  .container {\n    height: 100%;\n  }\n}\n\n.loader {\n  margin-top: -170px;\n}\n\n.loading-wrapper {\n  min-height: 300px;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n$wine-size-multiplier: 3;\n\n.wineglass {\n  height: 36px * $wine-size-multiplier;\n  position: relative;\n}\n\n.wineglass:after {\n  content: '';\n  position: absolute;\n  top: 47px * $wine-size-multiplier;\n  left: 5px * $wine-size-multiplier;\n  width: 20px * $wine-size-multiplier;\n  height: 5px * $wine-size-multiplier;\n  background: white;\n  box-shadow: 0 0 1px white;\n}\n\n.top {\n  background: white;\n  width: 30px * $wine-size-multiplier;\n  height: 36px * $wine-size-multiplier;\n  border-radius: 0 0 36px 36px;\n  box-shadow: 0 0 1px white;\n}\n\n.top:before {\n  content: '';\n  position: absolute;\n  left: 4px * $wine-size-multiplier;\n  bottom: 4px * $wine-size-multiplier;\n  width: 22px * $wine-size-multiplier;\n  height: 22px * $wine-size-multiplier;\n  border-radius: 50%;\n  background: linear-gradient(transparent 50%, $wine-red-light 50%);\n}\n\n.left .top:before {\n  animation: rotate2 2s linear infinite;\n}\n\n.right .top:before {\n  animation: rotate1 2s linear infinite;\n}\n\n.top:after {\n  content: '';\n  position: absolute;\n  top: 35px * $wine-size-multiplier;\n  left: 12px * $wine-size-multiplier;\n  width: 6px * $wine-size-multiplier;\n  height: 13px * $wine-size-multiplier;\n  background: white;\n  box-shadow: 0 0 1px white;\n}\n\n.left {\n  display: inline-block;\n  margin-right: 10px * $wine-size-multiplier;\n  animation: rotate1 2s cubic-bezier(.39, 1.52, .46, .92) infinite;\n}\n\n.right {\n  display: inline-block;\n  animation: rotate2 2s cubic-bezier(.39, 1.52, .46, .92) infinite;\n}\n\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  width: 70px * $wine-size-multiplier;\n  height: 25px * $wine-size-multiplier;\n  position: relative;\n  opacity: 0;\n  animation: 2s fadeInUp infinite linear 2s;\n}\n\nli {\n  width: 6px;\n  height: 15px;\n  background: white;\n  position: absolute;\n  box-shadow: 0 0 1px white;\n  transform-origin: bottom;\n}\n\nli:nth-child(1) {\n  left: 26px * $wine-size-multiplier;\n  bottom: 5px * $wine-size-multiplier;\n  transform: rotate(-35deg);\n}\n\nli:nth-child(2) {\n  left: 34px * $wine-size-multiplier;\n  bottom: 8px * $wine-size-multiplier;\n}\n\nli:nth-child(3) {\n  left: 42px * $wine-size-multiplier;\n  bottom: 5px * $wine-size-multiplier;\n  transform: rotate(35deg);\n}\n\n.small {\n  transform: scale(0.35);\n\n  &.loading-wrapper {\n    min-height: auto;\n  }\n\n  .loader {\n    margin-top: -100px;\n  }\n}\n\n.grey {\n  .wineglass:after {\n    background: $light-grey;\n    box-shadow: 0 0 1px $light-grey;\n  }\n\n  .top {\n    background: $light-grey;\n    box-shadow: 0 0 1px $light-grey;\n  }\n\n  .top:after {\n    background: $light-grey;\n    box-shadow: 0 0 1px $light-grey;\n  }\n\n  li {\n    background: $light-grey;\n    box-shadow: 0 0 1px $light-grey;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
